module.exports = __webpack_public_path__ + "static/media/thaili.7aca73fb.ogg";